import React, {useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../../App.css";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import MessageManagementStyles from "../../Messages/styles/MessageManagementStyles";
import MessageDetailsForm from "../../Messages/components/MessageDetailsForm";
import EnquiryMessageList from "./EnquiryMessageList";

function EnquiryEmailMessageManagement(props) {
  const classes = makeStyles(MessageManagementStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = props.canEdit;

  const [state, setState] = useState({
    selectedRecord: null
  });

  let theme = useTheme();
  const values = {
    xs: 0,
    sm: 600,
    lsm: 720,
    md: 960,
    mlg: 1120,
    lg: 1280,
    lgr: 1750,
    xl: 1920,
    xxl: 2400
  };

  theme.breakpoints = {...theme.breakpoints,
    keys: ['xs', 'sm', 'lsm', 'md', 'mlg', 'lg', 'lgr', 'xl', 'xxl'],
    up: key => `@media (min-width:${values[key]}px)`,
  };

  return (isAuthenticated &&
    <div
      className={classes.rooted}
      style={{ marginLeft: 20, marginRight: 20, minHeight: `calc(100vh - ${(99+2+10+57+4+16+68)}px)`, height: `calc(100vh - ${(99+2+10+57+4+16+68)}px)` }}
    >
      <div style={{display: "flex", width: "100%", position: "relative"}}>
        <div style={{display: "inline-flex", width: 1000, MinWidth: 970, maxWidth: 970, height: "100%"}}>
          <EnquiryMessageList
            canEdit={canEdit}
            classes={classes}
            theme={theme}
            height={99+2+10+57+4+16+68}
          />
        </div>
        <div style={{display: "inline-flex", position: "relative", width: `calc(100vw - 1065px)`, maxWidth: `calc(100vw - 1085px)`, marginLeft:20, backgroundColor: "#ffffff"}}>
          { !state.selectedRecord
            ?
              <div style={{position: "absolute", width: "100%", top: "50%", textAlign: "center", alignItems: "center", justifyContent: "center"}}>
                <Button color={"primary"}>Select a single message record to view and edit</Button>
              </div>
            :
              <></>
          }
          <MessageDetailsForm canEdit={true} classes={classes}/>
        </div>
      </div>
    </div>
  );
}

export default EnquiryEmailMessageManagement;
